import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import LightElement from './light-element.js';
import TrapFocus from '../../typescript/modules/trap-focus.js';

@customElement('confirm-dialog')
export class ConfirmDialog extends LightElement {

	@property({ type: String }) title = 'Confirm';
	@property({ type: String }) message = 'Are you sure?';
	@property({ type: String }) confirmText = 'Yes';
	@property({ type: String }) cancelText = 'No';

	@state() private open = false;
	private _resolver: ((result: boolean) => void) | null = null;

	connectedCallback() {
		super.connectedCallback();
		document.addEventListener('keydown', this.closeOnEscape.bind(this));
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		document.removeEventListener('keydown', this.closeOnEscape.bind(this));
	}

	show(message?: string, confirmText?: string, cancelText?: string): Promise<boolean> {
		this.message = message ?? this.message;
		this.confirmText = confirmText ?? this.confirmText;
		this.cancelText = cancelText ?? this.cancelText;
		this.open = true;

		setTimeout(() => {
			const confirmPopupElement = document.querySelector('.js-popup-confirm') as HTMLDialogElement;
			if (confirmPopupElement) {
				const firstFocusableElement = confirmPopupElement.querySelector('.js-popup-confirm-yes') as HTMLButtonElement;
				firstFocusableElement.focus();
				new TrapFocus(confirmPopupElement);
			}
		}, 200); // render delay


		return new Promise(resolve => {
			this._resolver = resolve;
		});
	}

	private _close(result: boolean) {
		this.open = false;
		this._resolver?.(result);
		this._resolver = null;
	}

	private closeOnEscape(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			this._close(false);
		}
	}

	render() {
		if (!this.open) return null;
		return html`
		<div id="popupFade" class="mPopupFade mPopupFade--show" @click=${() => this._close(false)}></div>
		<dialog id="popupConfirm" class="mPopup mPopup--show mPopup--confirm noPrint js-popup-confirm" open>
			<div class="mPopupInner" @click=${(e: Event) => e.stopPropagation()}>
				<h1 id="popupConfirmTitle">${this.title}</h1>
				<p id="popupConfirmText">${this.message}</p>
					<div class="formAction">
						<button id="popupConfirmYes" type="button" @click=${() => this._close(true)} class="formButton js-popup-confirm-yes" data-test="popup-yes-button">${this.confirmText} <span class="u-visuallyhidden">(closes overlay)</span></button>
						<button id="popupConfirmNo" type="button" @click=${() => this._close(false)} class="formButton formButtonGrey js-popup-confirm-no" data-test="popup-no-button">${this.cancelText} <span class="u-visuallyhidden">(closes overlay)</button>
					</div>
				<button class="mPopupClose" type="button" @click=${() => this._close(false)}><span class="u-visuallyhidden">Close overlay</span></button>
			</div>
		</dialog>
    `;
	}
}
